import { CountryCheckStatus, type CountryData } from './CardCountry.types';
import caFlag from './assets/ca.png';
import czFlag from './assets/cz.png';
import dkFlag from './assets/dk.png';
import itFlag from './assets/it.png';
import huFlag from './assets/hu.png';
import roFlag from './assets/ro.png';
import siFlag from './assets/si.png';
import skFlag from './assets/sk.png';
import uaFlag from './assets/ua.png';

/**
 * Przykładowe tytuły sprawdzeń
 */
export const mockCheckTitles = [
  'Ewidencja pojazdów skradzionych',
  'Rejestr pojazdów uszkodzonych',
  'Baza danych wypadków drogowych',
  'Ewidencja pojazdów w leasingu',
  'Rejestr pojazdów zastawnych',
  'Baza danych serwisowych',
  'Ewidencja pojazdów importowanych',
  'Rejestr pojazdów comercyjnych',
  'Baza danych ubezpieczeniowych',
];

/**
 * Przykładowe dane krajów
 */
export const mockCountries: CountryData[] = [
  {
    code: 'CA',
    name: 'Kanada',
    flagUrl: caFlag,
    status: CountryCheckStatus.OK,
  },
  {
    code: 'HU',
    name: 'Węgry',
    flagUrl: huFlag,
    status: CountryCheckStatus.OK,
  },
  {
    code: 'IT',
    name: 'Włochy',
    flagUrl: itFlag,
    status: CountryCheckStatus.OK,
  },
  {
    code: 'CZ',
    name: 'Czechy',
    flagUrl: czFlag,
    status: CountryCheckStatus.OK,
  },
  {
    code: 'DK',
    name: 'Dania',
    flagUrl: dkFlag,
    status: CountryCheckStatus.OK,
  },

  {
    code: 'SK',
    name: 'Słowacja',
    flagUrl: skFlag,
    status: CountryCheckStatus.OK,
  },

  {
    code: 'UA',
    name: 'Ukraina',
    flagUrl: uaFlag,
    status: CountryCheckStatus.OK,
  },

  {
    code: 'SI',
    name: 'Słowenia',
    flagUrl: siFlag,
    status: CountryCheckStatus.FOUND,
    recommendation: mockCheckTitles[2],
  },
  {
    code: 'RO',
    name: 'Rumunia',
    flagUrl: roFlag,
    status: CountryCheckStatus.UNKNOWN,
  },
];
